// Returns true if the version B is higher than version A
function compareVersions(versionA: string, versionB: string): boolean {
  if (versionA === versionB) {
    return true
  }
  // Split the version strings into arrays of integers
  const partsA: number[] = versionA.split('.').map(Number)
  const partsB: number[] = versionB.split('.').map(Number)

  // Compare each part of the version strings
  for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
    const partA: number = i < partsA.length ? partsA[i] : 0
    const partB: number = i < partsB.length ? partsB[i] : 0

    if (partB > partA) {
      return true
    } else if (partB < partA) {
      return false
    }
  }

  // If all parts are equal, check if version A has more parts
  return partsA.length < partsB.length
}

export { compareVersions }
